module.exports = __webpack_public_path__ + "static/img/404.74b9e380.png";